import React__default from 'react';
import { useController } from 'react-hook-form';
import { Dropdown } from '../../Dropdown.js';
import { FormItem } from '../FormItem.js';
import { ReadOnlyField, formatReadOnlyValue } from './ReadOnlyFormField.js';

/**
 * DropdownFormField - A form field component for dropdown/select input.
 *
 * @example
 * ```tsx
 * <Form schema={schema} onSubmit={handleSubmit}>
 *   <DropdownFormField
 *     schemaField="country"
 *     labelText="Country"
 *     options={[
 *       { id: 'us', label: 'United States' },
 *       { id: 'ca', label: 'Canada' },
 *     ]}
 *   />
 * </Form>
 * ```
 */
function DropdownFormField({ schemaField, labelText, descriptionText, isReadOnly, isDisabled, required, className, id, options, linkedField, showFieldToggle, ...dropdownProps }) {
    const { field } = useController({
        name: schemaField,
        shouldUnregister: false,
    });
    if (isReadOnly) {
        // Filter and map options to ensure they have required id property for formatReadOnlyValue
        const dropdownOptions = options
            .filter((option) => !!option.id)
            .map((option) => ({
            id: option.id,
            label: option.label,
        }));
        return (React__default.createElement(ReadOnlyField, { label: labelText, value: formatReadOnlyValue(field.value, 'dropdown', { dropdownOptions }), description: descriptionText, required: required, className: className }));
    }
    return (React__default.createElement(FormItem, { schemaField: schemaField, labelText: labelText, descriptionText: descriptionText, required: required, className: className, id: id, isDisabled: isDisabled, linkedField: linkedField, showFieldToggle: showFieldToggle },
        React__default.createElement(Dropdown, { ...dropdownProps, options: options, disabled: isDisabled, value: field.value, onSelectionChange: field.onChange })));
}

export { DropdownFormField };
//# sourceMappingURL=DropdownFormField.js.map
